/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ project: NonNullable<unknown>, group: NonNullable<unknown>, error: NonNullable<unknown> }} Explorer_Info_Batch_Error_GroupInputs */



/**
* | output |
* | --- |
* | "{project} / {group}: {error}" |
*
* @param {Explorer_Info_Batch_Error_GroupInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const explorer_info_batch_error_group = /** @type {((inputs: Explorer_Info_Batch_Error_GroupInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Explorer_Info_Batch_Error_GroupInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`${i?.project} / ${i?.group}: ${i?.error}`)
	if (locale === "de") return /** @type {LocalizedString} */ (`${i?.project} / ${i?.group}: ${i?.error}`)
	if (locale === "it") return /** @type {LocalizedString} */ (`${i?.project} / ${i?.group}: ${i?.error}`)
	if (locale === "ru") return /** @type {LocalizedString} */ (`${i?.project} / ${i?.group}: ${i?.error}`)
	if (locale === "es") return /** @type {LocalizedString} */ (`${i?.project} / ${i?.group}: ${i?.error}`)
	if (locale === "zh-CN") return /** @type {LocalizedString} */ (`${i?.project} / ${i?.group}: ${i?.error}`)
	if (locale === "ja") return /** @type {LocalizedString} */ (`${i?.project} / ${i?.group}: ${i?.error}`)
	if (locale === "hi") return /** @type {LocalizedString} */ (`${i?.project} / ${i?.group}: ${i?.error}`)
	if (locale === "pt-PT") return /** @type {LocalizedString} */ (`${i?.project} / ${i?.group}: ${i?.error}`)
	return /** @type {LocalizedString} */ (`${i?.project} / ${i?.group}: ${i?.error}`)
});